import React from "react";

class ClientsLogo1 extends React.Component {
  render() {
    return (
      <>
        <div className="section-full  mobile-page-padding p-t80 p-b10 bg-repeat">
          <div className="container">
            <div className="row">
              <div className="col-md-12 sx-separator-outer separator-center">
                <div className="case-banner">
                  <h1 className="mb__30">Advanced Amorphous</h1>
                </div>
              </div>
              <div className="col-lg-4 col-md-12 sx-separator-outer separator-center">
                <div className="case-logo custom__case_study_website_logo normal_logo">
                  <img
                    src={require("./../../../images/advanced_amorphous/logo.webp")}
                    className=""
                    alt="Shadow Case Study Logo"
                  />
                </div>
                <div className="mxnv046">
                  <h5 className="dfghj876543">Advanced Amorphous</h5>
                  <ul className="scnv-case mb__0">
                    <li>
                      <b>Location : </b>
                      1202, Ansal Tower, 38, Nehru Place, New Delhi-110019
                    </li>
                    <li>
                      <b>Speciality : </b> Electrical Insulation Materials
                      Provider
                    </li>
                    <li className="p__0">
                      <b>Website : </b>{" "}
                      <a
                        href="https://advancedamorphous.com/"
                        class="text-white"
                        target="_blank"
                      >
                        www.advancedamorphous.com
                      </a>
                    </li>
                  </ul>
                </div>
              </div>
              <div className="col-lg-8 col-md-12 sx-separator-outer">
                <div className="case-web-banner">
                  <img
                    src={require("./../../../images/advanced_amorphous/mobile_banner.webp")}
                    className="phone-banner"
                    alt="Shadow"
                  />
                  <img
                    src={require("./../../../images/advanced_amorphous/desktop_banner.webp")}
                    className="web-banner"
                    alt="Shadow"
                  />
                </div>
              </div>
            </div>
          </div>

          <div className="container">
            <div className="section-content">
              <div className="qpqq">
                <div className="row">
                  <div className="col-xl-12 col-lg-12 col-md-12">
                    <div className="bg-white">
                      <h2 class="ert678">Introduction</h2>
                      <p className="mb__0">
                        Founded in 2016, AAT Amorphous is a professional hi-tech
                        amorphous company engaged in R&D, manufacture, and
                        distribution of amorphous and latching relay related
                        products. By adopting this philosophy, they had been
                        constantly striving to become R & D and production
                        basement of the country and even the world for advanced
                        materials, to be a high-quality supplier for amorphous
                        and latching relay materials.
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </>
    );
  }
}

export default ClientsLogo1;
